var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "w-full flex items-center border py-2 px-2 rounded relative",
        class: _vm.error ? "border-red-700" : "border-secondary3",
        style: _vm.type === "textarea" ? "" : "height: 46px"
      },
      [
        _vm.label
          ? _c(
              "label",
              {
                staticClass: "absolute text-xs font-medium px-1",
                class: _vm.error
                  ? "text-red-700 " + _vm.bglabel
                  : "text-secondary3 " + _vm.bglabel,
                staticStyle: { top: "-0.625rem", left: "0.5rem" },
                attrs: { for: _vm.name }
              },
              [_vm._v(_vm._s(_vm.label))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "textarea"
          ? _c("textarea-autosize", {
              staticClass:
                "bg-transparent border-none w-full text-sm md:text-base text-secondary3 placeholder-placeholder py-1 px-1 leading-tight focus:outline-none",
              attrs: {
                value: _vm.value,
                readonly: _vm.readonly,
                placeholder: _vm.placeholder,
                "max-height": 120,
                "min-height": _vm.height
              },
              nativeOn: {
                blur: function($event) {
                  return _vm.onInput($event)
                }
              }
            })
          : _vm.type === "duration"
          ? _c("input", {
              staticClass:
                "html-duration-picker bg-transparent border-none w-full text-secondary3 placeholder-placeholder py-1 px-1 leading-tight focus:outline-none",
              attrs: {
                name: _vm.name,
                type: "text",
                maxLength: "8",
                readonly: _vm.readonly,
                placeholder: _vm.placeholder
              },
              domProps: { value: _vm.durationValue },
              on: { input: _vm.onInputDuration }
            })
          : _c("input", {
              staticClass:
                "bg-transparent border-none w-full text-secondary3 placeholder-placeholder py-1 px-1 leading-tight focus:outline-none",
              attrs: {
                id: _vm.name,
                name: _vm.name,
                min: _vm.min,
                max: _vm.max,
                step: _vm.step,
                type: _vm.type,
                readonly: _vm.readonly,
                placeholder: _vm.placeholder
              },
              domProps: { value: _vm.value },
              on: { input: _vm.onInput }
            }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: "absolute px-2 " + _vm.bglabel,
            staticStyle: { right: "0.5rem" }
          },
          [_vm._v(_vm._s(_vm.extend))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.error && _vm.showError
      ? _c("div", {
          staticClass: "mt-1 ml-3 text-red-700 text-xs",
          domProps: { innerHTML: _vm._s(_vm.error) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-051ef74e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051ef74e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomInput.vue
// module id = null
// module chunks = 